export const SR_CREATE_FORM_FIELDS = Object.freeze({
  email: 'email',
  postalCode: 'postalCode',
})
